<template>
    <div
        :style="{ backgroundColor: bannerColor }"
        class="cz2__rounded-banner"
    >
        <span>
            {{ bannerCopy }}
        </span>
    </div>
</template>

<style lang="scss">
    @import '../../style/variables';

    #cz2.cz2 {
        .cz2__rounded-banner {
            margin-bottom: 8px;
            padding: 0 8px;
            width: fit-content;
            height: 24px;

            font-size: 15px;
            font-weight: 900;
            font-style: italic;
            line-height: 32px;
            color: white;
            text-transform: uppercase;

            display: flex;
            align-items: center;

            background: #707070;

            clip-path: polygon(
                0.015% 18.196%,
                0.028% 14.570%,
                0.200% 11.159%,
                0.514% 8.050%,
                0.954% 5.328%,
                1.504% 3.077%,
                2.145% 1.382%,
                2.861% 0.329%,
                3.635% 0.003%,

                96.131% 7.601%,
                96.951% 8.109%,
                97.695% 9.418%,
                98.345% 11.421%,
                98.883% 14.009%,
                99.291% 17.072%,
                99.549% 20.501%,
                99.641% 24.188%,
                99.547% 28.023%,

                97.135% 76.668%,
                96.950% 79.344%,
                96.678% 81.788%,
                96.329% 83.963%,
                95.910% 85.834%,
                95.433% 87.366%,
                94.906% 88.523%,
                94.338% 89.271%,
                93.739% 89.573%,

                4.959% 99.310%,
                4.270% 99.077%,
                3.622% 98.259%,
                3.027% 96.913%,
                2.499% 95.093%,
                2.051% 92.854%,
                1.696% 90.252%,
                1.447% 87.341%,
                1.318% 84.177%
            );
        }
    }
</style>

<script>
    export default {
        props: {
            bannerCopy: {
                type: String,
                default: '',
            },

            bannerColor: {
                type: String,
                default: '',
            },
        },
    };
</script>
